/**
 * Textes du lot B : les espaces de test et l'invitation de la direction d'une
 * galerie. Fichier à part, comme `i18nSaisies.ts`, pour ne pas toucher aux
 * blocs de `i18n.ts` que d'autres écrans éditent ; ses blocs sont fusionnés
 * dans le namespace `console` (D15). Voix 2.2 : phrases courtes, un verbe.
 */

export const frEspaces = {
  espaceTest: {
    badge: 'Test',
    filtreLabel: 'Espaces de test',
    filtre: {
      tous: 'Tous',
      masquer: 'Masquer les tests',
      seulement: 'Seulement les tests',
    },
    interrupteur: 'Espace de test',
    aide: 'Hors des chiffres de pilotage et de facturation : vue d’aigle, abonnements, sommes dues.',
    caseCreation: 'Espace de test',
    aideCreation:
      'Pour essayer la plateforme. Hors des chiffres de pilotage et de facturation. Seule la direction de Venio peut ensuite retirer ce marquage.',
    marque: 'Galerie marquée comme espace de test.',
    demarque: 'Marquage de test retiré.',
    erreur: 'Le marquage n’a pas changé. Réessayez.',
  },
  invitationDirection: {
    envoyee: 'Invitation envoyée à {{email}}.',
    nonEnvoyee:
      'L’invitation n’est pas partie. Vérifiez l’envoi des courriels, puis renvoyez-la depuis l’onglet Membres.',
    enAttente: 'Invitation en attente',
    renvoyer: 'Renvoyer l’invitation',
    renvoi: 'Envoi…',
    renvoyee: 'Nouvelle invitation envoyée à {{email}}. L’ancien lien ne vaut plus.',
    nonRenvoyee:
      'Nouveau lien créé pour {{email}}, mais le courriel n’est pas parti. L’ancien lien ne vaut plus.',
    erreur: 'L’invitation n’a pas été renvoyée. Réessayez.',
    dejaActive: 'Cette direction a déjà accepté son invitation : rien à renvoyer.',
  },
};

export const enEspaces: typeof frEspaces = {
  espaceTest: {
    badge: 'Test',
    filtreLabel: 'Test spaces',
    filtre: {
      tous: 'All',
      masquer: 'Hide test spaces',
      seulement: 'Test spaces only',
    },
    interrupteur: 'Test space',
    aide: 'Left out of every management and billing figure: eagle view, subscriptions, amounts due.',
    caseCreation: 'Test space',
    aideCreation:
      'To try the platform. Left out of every management and billing figure. Only Venio’s management can remove this mark later.',
    marque: 'Gallery marked as a test space.',
    demarque: 'Test mark removed.',
    erreur: 'The mark did not change. Try again.',
  },
  invitationDirection: {
    envoyee: 'Invitation sent to {{email}}.',
    nonEnvoyee:
      'The invitation was not sent. Check email delivery, then resend it from the Members tab.',
    enAttente: 'Invitation pending',
    renvoyer: 'Resend the invitation',
    renvoi: 'Sending…',
    renvoyee: 'New invitation sent to {{email}}. The previous link no longer works.',
    nonRenvoyee:
      'New link created for {{email}}, but the email was not sent. The previous link no longer works.',
    erreur: 'The invitation was not resent. Try again.',
    dejaActive: 'This director has already accepted the invitation: nothing to resend.',
  },
};
